import {observer} from "mobx-react";
import {ModalDialog, Page, PageContentTitle} from "../../ui";
import {DialogStore, fmsCreateStore, growlStore, validationStore} from "../../../store";
import {useState} from "react";
import {useNavigate} from "react-router";
import {FmsCreateForm, FmsFormValidation} from "./FmsCreateForm";
import {fmsCustomerStore} from "../../../store/fms/FmsCustomerStore";
import {PageTopperCustomerVehicleWidget} from "../../../widgets";

const FmsCreatePage = observer(function FmsCreatePage() {
    const [cancelDialog] = useState(new DialogStore())
    const navigate = useNavigate()

    const validation: FmsFormValidation = {
        vin: validationStore.getFor('vin'),
        documentType: validationStore.getFor('documentType'),
        customer: validationStore.getFor('customerId'),
        process: validationStore.getFor('process'),
        city: validationStore.getFor('receiver.address.city'),
        addition: validationStore.getFor('receiver.address.addition'),
        country: validationStore.getFor('receiver.address.country'),
        houseNumber: validationStore.getFor('receiver.address.houseNumber'),
        postCode: validationStore.getFor('receiver.address.postCode'),
        street: validationStore.getFor('receiver.address.street'),
        line1: validationStore.getFor('receiver.line1'),
        line2: validationStore.getFor('receiver.line2'),
        mail: validationStore.getFor('receiver.mail'),
        phone: validationStore.getFor('receiver.phone'),
        shipmentType: validationStore.getFor('shipmentType'),
    }

    const display = 'Neuen Versandauftrag anlegen'

    return <Page
        breadcrumb={[
            {
                link: '/fms',
                label: 'Versand'
            },
            {
                link: '/fms/create',
                label: display
            }
        ]}
        topper={<PageTopperCustomerVehicleWidget customerId={fmsCreateStore.customer?.id} vin={fmsCreateStore.vin}/>}
    >
        <ModalDialog
            store={cancelDialog}
            actions={[
                {
                    label: "Abbrechen",
                    execute: async function () {
                        cancelDialog.dialogOpen = false
                    },
                    className: 'is-primary is-rounded is-small'
                },
                {
                    label: "Verwerfen",
                    execute: async function () {
                        fmsCreateStore.reset()
                        cancelDialog.dialogOpen = false
                        navigate('/fms')
                    },
                    className: 'is-rounded is-small'
                }
            ]}
            title={"Änderungen verwerfen?"}
        >
            Sind Sie sich sicher, dass Sie die Änderungen verwerfen wollen?
        </ModalDialog>
        <PageContentTitle
            actions={[
                {
                    label: 'Speichern',
                    cls: `is-primary ${fmsCreateStore.creating ? 'is-loading' : ''}`,
                    disabled: !(fmsCreateStore.dirty && fmsCreateStore.valid),
                    action: async () => {
                        const success = await fmsCreateStore.create()
                        if (success) {
                            fmsCreateStore.reset()
                            growlStore.add({
                                message: 'Der Versandauftrag wurde erfolgreich hinzugefügt',
                                autoclose: true,
                                closable: true
                            })
                            navigate(`/fms`)
                        }
                    }
                },
                {
                    label: 'Verwerfen',
                    cls: 'is-primary is-outlined',
                    disabled: fmsCreateStore.creating || !fmsCreateStore.dirty,
                    action: async () => {
                        cancelDialog.dialogOpen = true
                    }
                },
            ]}
        >{display}</PageContentTitle>
        <FmsCreateForm
            disabled={fmsCreateStore.creating}
            validation={validation}
            customers={fmsCustomerStore.items}
            data={fmsCreateStore.formData}
            onSearchCustomer={v => fmsCustomerStore.search(v)}
            onChange={data => fmsCreateStore.formData = data}
            onBlur={() => fmsCreateStore.validate()}
        />
    </Page>
})

export {
    FmsCreatePage
}
